import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const CourseHeader = ({ length, className, editable }) => (
    <div className={classNames('d-flex border-bottom py-3 ai-center', className)}>
        <div className="d-flex-12 dsl-m12">Courses ({length})</div>
        <div className={classNames('d-flex-3 dsl-m12 desktop-screen', editable ? 'text-center' : 'text-right')}>Assigned</div>
        {!editable && <div className="d-flex-2 dsl-m12 text-end">Completed</div>}
        <div className="d-flex-3 dsl-m12 text-center desktop-screen">Due Date</div>
        {editable && <div className="d-flex-1 dsl-m12" />}
    </div>
);

CourseHeader.propTypes = {
    length: PropTypes.number,
    className: PropTypes.string,
    editable: PropTypes.bool,
};

CourseHeader.defaultProps = {
    length: 0,
    className: '',
    editable: true,
};

export default CourseHeader;
